import { AGRANDIR_LE_PAPIER } from '../partage/vocabulaire';

/**
 * La poignée du coin bas droit d'un papier (chantier post-it-et-listes, ticket 03) : on la tire
 * pour régler largeur et hauteur, bornées. La même pour le post-it et la liste libre (ticket 04) ;
 * le geste est dans `useGlisserUnPapier`.
 */
export function PoigneeDuPapier({ onPointerDown }: { onPointerDown: (evenement: React.PointerEvent) => void }) {
  return (
    <span className="papier-poignee" title={AGRANDIR_LE_PAPIER} aria-hidden="true" onPointerDown={onPointerDown}>
      <svg viewBox="0 0 12 12">
        <path d="M11 4 4 11M11 8l-3 3" />
      </svg>
    </span>
  );
}
